import {platformFeeApi} from "@/apis/apis";
import BaseTable from "../BaseTable";
import {columns} from "./Columns";
import PlatformFeeModal from "@/Modals/FinanceManagement/PlatformFees/Modal";

export default function PlatformFeePage() {
  return (
    <BaseTable
      label="Platform Fee"
      apiURL={platformFeeApi}
      columns={columns()}
      ModalComponent={PlatformFeeModal}
      enableAdd={true}
      enableDelete={false}
      enableActions={true}
      importData={null}
      enableExport={false}
      enableStatus={false}
      enableSortData={false}
    />
  );
}
